import { apiClient } from '~api/client';
import type { BlastOptimisationsResponse } from './optimiser.types';

/**
 * Optimiser service for pattern design optimisations
 */
const optimiserService = {
  /**
   * Fetch pattern design optimisations
   * @returns Promise resolving to optimisations response
   */
  getPatternDesignOptimisations: async (): Promise<BlastOptimisationsResponse[]> => {
    const response = await apiClient.get<BlastOptimisationsResponse[]>('/pattern_design_optimisations/', {
      params: { crs: 'local' },
    });
    return response.data;
  },

  /**
   * Fetch pattern design optimisations for a specific blast
   * @param blastName - Name of the blast
   * @returns Promise resolving to optimisations response for the blast
   */
  getPatternDesignOptimisationsByBlast: async (blastName: string): Promise<BlastOptimisationsResponse> => {
    const response = await apiClient.get<BlastOptimisationsResponse>(
      `/pattern_design_optimisations/${encodeURIComponent(blastName)}`,
      { params: { crs: 'local' } },
    );
    return response.data;
  },

  /**
   * Trigger a new pattern design optimisation build for a blast
   * @param blastName - Name of the blast to optimise
   * @returns Promise resolving when the optimisation build has been triggered
   */
  triggerOptimisationBuild: async (blastName: string): Promise<void> => {
    await apiClient.get(`/pattern_design_optimisations/pending`, {
      params: { pattern_name: blastName, write_job: true },
    });
  },
};

export { optimiserService };
